import { callZigzagFunction } from '../../callZigzagFunction';
import { zigzagHandler } from '../../handlers';

// 쇼핑몰 즐겨찾기 삭제
export const rbk = (shopMainDomain: string) => {
  return new Promise<boolean>(resolve => {
    callZigzagFunction('rbk')({ shopMainDomain });
    zigzagHandler('onBookmarkStatus', maps => {
      resolve(maps[shopMainDomain]);
    });
  });
};
